<template>
  <div class="stripe_card">
    <div class="list-card" v-if="cards && cards.length">
      <div class="list-card--block" v-for="card in cards" :key="card.id">
        <div class="list-card__image">
          <div v-if="card.brand === 'Visa'" class="svg__card-wrapper">
            <svg
              class="svg__card"
              width="29"
              height="29"
              viewBox="0 0 29 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.16 5.39418C0.519477 5.39418 0 5.91351 0 6.55418V22.4462C0 23.0868 0.519738 23.6062 1.16 23.6062H27.84C28.4805 23.6062 29 23.0869 29 22.4462V6.55418C29 5.91354 28.4803 5.39418 27.84 5.39418H1.16ZM17.3202 10.8217C18.0261 10.8217 18.5917 10.9776 18.9524 11.1226L18.7059 12.6732L18.5428 12.5907C18.2068 12.4457 17.7751 12.3062 17.1798 12.3161C16.4671 12.3161 16.1376 12.634 16.1376 12.9315C16.1335 13.2666 16.5226 13.4877 17.1589 13.8187C18.2092 14.3294 18.6946 14.9486 18.6878 15.7626C18.6737 17.2479 17.4314 18.2077 15.5177 18.2077C14.7013 18.1987 13.9147 18.0258 13.4895 17.8261L13.7451 16.2239L13.9798 16.3381C14.5777 16.6052 14.9649 16.7133 15.6935 16.7133C16.2168 16.7133 16.7784 16.4942 16.7829 16.0145C16.7862 15.7013 16.5481 15.478 15.8394 15.1273C15.1489 14.785 14.2334 14.2116 14.2436 13.1834C14.2543 11.7925 15.5214 10.8217 17.3202 10.8217ZM2.56467 11.0492H5.50365C5.89941 11.0641 6.21893 11.1916 6.32925 11.621L6.96273 14.8908C6.96281 14.8911 6.96261 14.8923 6.96273 14.8926L7.15302 15.8723L8.93742 11.0492H10.8677L7.99855 18.1089L6.07005 18.1107L4.53487 12.414C5.44832 12.8979 6.22598 13.4578 6.67635 14.2283C6.56023 13.9845 6.40723 13.7093 6.21145 13.4381C5.98345 13.1222 5.49106 12.7144 5.28525 12.5409C4.56808 11.9363 3.59411 11.448 2.54202 11.1897L2.56467 11.0492ZM11.6354 11.0573H13.5231L12.3422 18.1062H10.4545L11.6354 11.0573ZM22.2974 11.0573H23.7275L25.2246 18.1062H23.5081C23.5081 18.1062 23.3378 17.2964 23.2825 17.0495C23.0127 17.0495 21.1258 17.0468 20.9135 17.0468C20.8417 17.2376 20.5238 18.1061 20.5238 18.1061H18.5817L21.3286 11.6428C21.5231 11.1835 21.8546 11.0573 22.2974 11.0573ZM22.4379 12.9532C22.345 13.2154 22.1832 13.6388 22.194 13.6202C22.194 13.6202 21.613 15.17 21.4609 15.5723L22.9879 15.5714C22.9144 15.2218 22.562 13.555 22.562 13.555L22.4379 12.9533V12.9532Z"
                fill="#B2B9C4"
              />
            </svg>
          </div>
          <div v-if="card.brand === 'Discover'">
            <img
              class="svg__card-icon"
              src="../../assets/images/stripe/discover.svg"
              alt="discover"
            />
          </div>
          <div v-if="card.brand === 'Diners Club'">
            <img
              class="svg__card-icon"
              src="../../assets/images/stripe/diners-club.svg"
              alt="diners-club"
            />
          </div>
          <div v-if="card.brand === 'UnionPay'">
            <img
              class="svg__card-icon"
              src="../../assets/images/stripe/unionpay.svg"
              alt="unionpay"
            />
          </div>
          <div v-if="card.brand === 'American Express'">
            <img
              class="svg__card-icon"
              src="../../assets/images/stripe/american-express.svg"
              alt="american-express"
            />
          </div>
          <div v-if="card.brand === 'JCB'">
            <img class="svg__card-icon" src="../../assets/images/stripe/jcb.svg" alt="jcb" />
          </div>
          <div v-if="card.brand === 'Unknown'">
            <img
              class="svg__card-icon"
              src="../../assets/images/stripe/unknown.svg"
              alt="unknown"
            />
          </div>
          <div v-if="card.brand === 'MasterCard'" class="svg__card-wrapper">
            <svg
              class="svg__card"
              width="29"
              height="29"
              viewBox="0 0 29 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.0846 9.05143C13.0106 8.35048 11.8316 8 10.5477 8C9.68345 8 8.85482 8.16699 8.06185 8.50098C7.26888 8.83496 6.5871 9.28234 6.01649 9.8431C5.44589 10.4039 4.99067 11.0718 4.65083 11.847C4.31098 12.6222 4.14106 13.4345 4.14106 14.2839C4.14106 15.1415 4.31098 15.9579 4.65083 16.7331C4.99067 17.5082 5.44589 18.1762 6.01649 18.737C6.5871 19.2977 7.26678 19.7451 8.05556 20.0791C8.84433 20.4131 9.67506 20.5801 10.5477 20.5801C11.8316 20.5801 13.0106 20.2296 14.0846 19.5286C12.9854 18.6463 12.2386 17.5515 11.8442 16.2445C11.4498 14.9374 11.4519 13.6324 11.8505 12.3294C12.2491 11.0265 12.9938 9.93381 14.0846 9.05143ZM14.5 9.34831C13.4427 10.1647 12.7211 11.1935 12.3351 12.4346C11.9491 13.6757 11.947 14.9147 12.3288 16.1517C12.7106 17.3887 13.4343 18.4154 14.5 19.2318C15.5657 18.4154 16.2894 17.3887 16.6712 16.1517C17.053 14.9147 17.0509 13.6757 16.6649 12.4346C16.2789 11.1935 15.5573 10.1647 14.5 9.34831ZM14.9154 9.05143C16.0062 9.93381 16.7509 11.0285 17.1495 12.3356C17.5481 13.6427 17.5502 14.9498 17.1558 16.2568C16.7614 17.5639 16.0146 18.6545 14.9154 19.5286C15.9894 20.2296 17.1684 20.5801 18.4523 20.5801C19.3249 20.5801 20.1557 20.4131 20.9444 20.0791C21.7332 19.7451 22.4129 19.2977 22.9835 18.737C23.5541 18.1762 24.0093 17.5082 24.3492 16.7331C24.689 15.9579 24.8589 15.1415 24.8589 14.2839C24.8589 13.4345 24.689 12.6222 24.3492 11.847C24.0093 11.0718 23.5541 10.4039 22.9835 9.8431C22.4129 9.28234 21.7311 8.83496 20.9382 8.50098C20.1452 8.16699 19.3166 8 18.4523 8C17.1684 8 15.9894 8.35048 14.9154 9.05143ZM24.2422 17.9824H24.3303V17.9453H24.1163V17.9824H24.2044V18.1927H24.2422V17.9824ZM24.6072 18.1927H24.6576V17.9453H24.5946L24.5191 18.1061L24.4436 17.9453H24.3806V18.1927H24.4184V18.0072L24.4939 18.168H24.5443L24.6072 18.0072V18.1927ZM29 6.58333V22.4167C29 22.8455 28.8406 23.2166 28.5217 23.5299C28.2028 23.8433 27.8252 24 27.3889 24H1.61111C1.17477 24 0.797164 23.8433 0.478299 23.5299C0.159433 23.2166 0 22.8455 0 22.4167V6.58333C0 6.15451 0.159433 5.78342 0.478299 5.47005C0.797164 5.15668 1.17477 5 1.61111 5H27.3889C27.8252 5 28.2028 5.15668 28.5217 5.47005C28.8406 5.78342 29 6.58333 29 6.58333Z"
                fill="#B2B9C4"
              />
            </svg>
          </div>
        </div>
        <div class="list-card__code_card">XXXX XXXX XXXX {{ card.last4 }}</div>
        <button
          id="delete-card-btn"
          class="list-card__button-delete"
          @click.prevent="deleteCard(card.id)"
          @mouseenter="showLabel($event, card.id)"
          @mouseleave="showHintDeleteLabel = null"
        >
          <p
            v-show="showHintDeleteLabel !== null && showHintDeleteLabel === card.id"
            class="delete-report-btn-title"
          >
            Delete card
          </p>
          <img
            class="icon-action btn"
            src="../../assets/images/myScans/icon_action_delete.svg"
            alt="icon_action_delete"
          />
        </button>
      </div>
    </div>
    <div class="new-card">
      <div class="new-card__title">Add New Card</div>
      <div class="new-card--block">
        <NewCard :cardElement="this.cardElement" :elements="this.elements" />
      </div>
      <div id="add-card-message" class="add-card-message"></div>
      <div class="new-card--add-card">
        <button id="button_add_card" v-on:click="saveCard" class="new-card--add-card__button">
          Add New Card
        </button>
      </div>
    </div>
    <div class="spinner" v-if="showSpinner">
      <Spinner />
    </div>
  </div>
</template>
<script>
import NewCard from '../NewCard';
import Spinner from '../Spinner';
import { mapGetters } from 'vuex';
import { paymentCardNotification } from '@/services/notificationService/notificationService.js';

const STRIPE_PUBLIC_KEY = process.env.VUE_APP_STRIPE_PUBLIC_KEY;

export default {
  components: {
    NewCard,
    Spinner,
  },
  data() {
    return {
      isNewCard: false,
      showSpinner: false,
      elements: null,
      cardElement: {
        cardNumber: null,
        cardExpiry: null,
        cardCvc: null,
      },
      showHintDeleteLabel: null,
    };
  },
  async beforeMount() {
    this.showSpinner = true;
    this.stripe = Stripe(STRIPE_PUBLIC_KEY);
    this.elements = this.stripe.elements();
    await this.$store.dispatch('jobs/loadJobsHistory');
    await this.$store.dispatch('stripe/fetchCards');
    this.showSpinner = false;
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    ...mapGetters({
      cards: 'stripe/cards',
    }),
  },
  methods: {
    async deleteCard(id_card) {
      this.showSpinner = true;
      await this.$store.dispatch('stripe/deleteCard', { id: id_card });
      this.paymentCardNotification('removed');
      this.showSpinner = false;
    },
    clearCardElements() {
      this.cardElement.cardNumber.clear();
      this.cardElement.cardExpiry.clear();
      this.cardElement.cardCvc.clear();
    },
    async saveCard() {
      this.showSpinner = true;
      const messageAddCard = document.getElementById('add-card-message');
      messageAddCard.textContent = '';
      const { token, error } = await this.stripe.createToken(this.cardElement.cardNumber);
      if (token) {
        const res = await this.$store.dispatch('stripe/saveCard', { id: token.id });
        if (res && res.status === 200) {
          this.paymentCardNotification('added');
          this.clearCardElements();
        } else if (res && res.status === 422) {
          messageAddCard.textContent = 'Card already added';
        } else {
          messageAddCard.textContent = 'Payment method declined';
        }
      } else {
        messageAddCard.textContent = 'Please enter a valid credit card';
      }
      this.showSpinner = false;
    },
    showLabel(event, id) {
      this.showHintDeleteLabel = id;
    },
    handleScroll() {
      this.showHintDeleteLabel = null;
    },
    paymentCardNotification,
  },
};
</script>
<style lang="scss" scoped>
.spinner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 1000;
}
</style>
